/**
 * 转换表单格式数据
 * @param {*} data
 * @returns
 */
export const tableFormUtils = (data) => {
  let ret = ''
  for (let it in data) {
    ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
  }
  return ret.slice(0, -1)
}
